import axios from "axios";
import Vue from "vue";
import moment from 'vue-moment';
import Vuex from "vuex";

import createPersistedState from 'vuex-persistedstate';

import { deliverableChat } from "./modules/chat";
import { projectChat } from "./modules/chat";

import { deliverables } from "./modules/deliverables";
import { relatedDeliverables } from "./modules/deliverables";
import { relatedDeliverablesCalendar } from "./modules/deliverables";

import { deliverableTemplates } from "./modules/deliverableTemplates";

import { colorThemeVariables } from "./modules/colorThemeVariables";

Vue.use(Vuex);
Vue.use(moment)

Vue.set(deliverables.state, '_namespace', "");
Vue.set(relatedDeliverables.state, '_namespace', "relatedDeliverables/");
Vue.set(relatedDeliverablesCalendar.state, '_namespace', "relatedDeliverablesCalendar/");

Vue.set(deliverableTemplates.state, '_namespace', "deliverableTemplates/");


export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: 'CSM_FILTER_STATE',
            paths: [
                'deliverables.deliverableFilter', 
                'deliverables.myWeekDeliverableFilter', 
                'deliverables.mediaCallFilter',
                'deliverables.globalSearchFilter', 
                'deliverables.GSRecentSearch',
                'deliverables.userViews', 
                'deliverables.projectFilter', 
                'deliverables.myProjectFilter',
                'deliverables.calendarFilter',
                'deliverables.projectSort',
                'deliverables.myProjectSort',
                'deliverables.socialMediaFilter',
                'deliverables.socialMediaCalendarFilter',
            ],
        }),
        createPersistedState({
            key: 'CSM_SORTING_OPTIONS',
            paths: [
                'deliverables.storedSortKey',
                'deliverables.storedSortState',
                'deliverables.storedSortFieldId',
                'deliverables.storedTaskFieldsOrder',
                'deliverables.storedTaskOrder',
                'deliverables.nextSortState',
                'deliverableTemplates.storedSortKey',
                'deliverableTemplates.storedSortState',
                'deliverableTemplates.storedSortFieldId',
                'deliverableTemplates.storedTaskFieldsOrder',
                'deliverableTemplates.storedTaskOrder',
                'deliverableTemplates.nextSortState',
            ]
        })
    ],
    modules: {
        deliverables: deliverables
        ,relatedDeliverables: relatedDeliverables
        ,relatedDeliverablesCalendar: relatedDeliverablesCalendar
        ,deliverableTemplates: deliverableTemplates
        ,colorThemeVariables: colorThemeVariables
        ,deliverableChat
        ,projectChat
    },
    state: {
        token: localStorage.getItem("token") || "",
        user: "",
        status: "",
        userAbilities: localStorage.getItem("userAbilities") ? JSON.parse(localStorage.getItem("userAbilities")) : "",
    },
    mutations: {
    	// bindNamespace(_, {module, namespace}) {
        //  	Vue.set(module.state, '_namespace', namespace);
    	// },
        auth_request(state) {
            state.state = "loading";
        },
        auth_error(state) {
            state.state = "error";
        },
        auth_success(state, data) {
            state.status = "success";
            state.token = data.token;
            state.userAbilities = data.userAbilities;
        },
        setDefaultSort(state) {
            const storedSortKey = localStorage.getItem('storedSortKey')
            if(storedSortKey === null) {
                localStorage.setItem('storedSortState', 'ASC')
                localStorage.setItem('nextSortState', 'DESC')
                localStorage.setItem('storedSortKey', 'created_date')
                state.storedSortKey = 'created_date'
                state.nextSortState = 'DESC'
                state.storedSortState = 'ASC'
            } 
        },
        logout(state) {
            state.status = "";
            state.token = "";
            state.user = null;
        }
    },
    actions: {
    	// bindNamespaces({commit}, {_modulesNamespaceMap}) {
        //   Object.entries(_modulesNamespaceMap).forEach(([namespace, module]) => {
        //       commit('bindNamespace', {module, namespace});
        //   });
    	// },
        login({ commit }, loginData) {
            return new Promise((resolve, reject) => {
                commit("auth_request");
                axios
                    .post(process.env.MIX_API_BASE_URL + "login", loginData)
                    .then(response => {
                        const token = response.data.token;
                        localStorage.setItem("token", token);
                        localStorage.setItem("user", response.data.user.name);
                        localStorage.setItem("userId", response.data.user.id);
                        localStorage.setItem("userAbilities", JSON.stringify(response.data.userAbilities));
                        axios.defaults.headers.common["Authorization"] =
                            "Bearer " + token;
                        commit("auth_success", response.data);
                        commit("setDefaultSort");

                        // set token cookie
                        const d = new Date();
                        d.setTime(d.getTime() + 24*3600*1000);
                        document.cookie = `auth_token=${token};expires=${d.toUTCString()};path=/`;

                        resolve(response);
                    })
                    .catch(err => {
                        commit("auth_error");
                        localStorage.removeItem("token");
                        
                        // clear token cookie
                        document.cookie = "auth_token=;path=/";

                        reject(err);
                    });
            });
        },
        async sendResetPasswordEmail({ commit }, payload) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + "sendResetPasswordEmail",
                payload
            )
            return response
        },
        async resetPassword({ commit }, payload) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + "resetPassword",
                payload
            )
            return response
        },
        async register({}, registerData) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + "register",
                registerData
            );
            return response;
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit("logout");
                localStorage.removeItem("dashboardActiveSave");
                localStorage.removeItem("myWeekActiveSave");
                localStorage.removeItem("mediaCallActiveSave");
                localStorage.removeItem("dashboardActiveSaveTitle");
                localStorage.removeItem("myWeekActiveSaveTitle");
			    localStorage.removeItem("mediaCallActiveSaveTitle");
                localStorage.removeItem("currentFilterData");
                localStorage.removeItem("dashboardActiveSaveData");
                localStorage.removeItem("myWeekActiveSaveData");
                localStorage.removeItem("mediaCallActiveSaveData");
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                localStorage.removeItem("userId");
                localStorage.removeItem("CSM_FILTER_STATE");
                localStorage.removeItem("userAbilities");
                delete axios.defaults.headers.common["Authorization"];
                // clear token cookie
                document.cookie = "auth_token=;path=/";
                location.reload()
                resolve();
            });
        },
        
        // For download files
        setUserAuthCookie({ getters }) {
            // set token cookie
            const d = new Date();
            d.setTime(d.getTime() + 24*3600*1000);
            document.cookie = `auth_token=${getters.authToken};expires=${d.toUTCString()};path=/`;
        },

        setLoginInformation({ commit }, r) {
            const token = r.data.token;
            localStorage.setItem("token", token);
            localStorage.setItem("user", r.data.user.name);
            localStorage.setItem("userId", r.data.user.id);
            localStorage.setItem("userAbilities", JSON.stringify(r.data.userAbilities));
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
            commit("auth_success", r.data);
            commit("setDefaultSort");

            // set token cookie
            const d = new Date();
            d.setTime(d.getTime() + 24*3600*1000);
            document.cookie = `auth_token=${token};expires=${d.toUTCString()};path=/`;

            return r;
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authToken: state => state.token,
        userAbilities: state => state.userAbilities
    }
});
